import React, { useReducer, useEffect } from 'react'
import AxiosClient from '../../config/AxiosClient'
import AuthReducer from './AuthReducer'
import AuthContext from './'

import { 
    TOKEN_SUCCESS,
    AUTH_SUCCESS,
    AUTH_FAIL,
    AUTH_ACTIVE,
    SUBS_ACTIVE,
    SESSION_CLOSE
} from './AuthTypes';

const AuthState = ({children}) => {
    const initialState ={
        token: null,
        authenticated: false,
        subcribed: false,
        claims: null,
        error: null
    }
    const localState = JSON.parse(localStorage.getItem("session"))
    const CONTROLLER_ACCOUNT = "api/account"
    const CONTROLLER_STRIPE = "api/stripe"
    const [session, setSession] = useReducer(AuthReducer, localState || initialState);
    
    if (localState !== null) localState.error = null
        
    useEffect(() => {
        localStorage.setItem("session", JSON.stringify(session));
    }, [session]);
    
    const login = async data => {
        await AxiosClient().post(`${CONTROLLER_ACCOUNT}/login`, data)
        .then(response => {
            switch (response.status) {
                case 200:
                    tokenSuccess(response.data.token)
                  break;
                default:
                    setSession({
                        type: AUTH_FAIL,
                        payload: response.data
                    })
            }
        }).catch(error => {
            console.error(error)
        });
    }

    const logout = () => {
        setSession({
            type: SESSION_CLOSE
        })
    }

    const refresh = async () => {
        await AxiosClient().post(`${CONTROLLER_ACCOUNT}/refresh`)
        .then(response => {
            switch (response.status) {
                case 200:
                    tokenSuccess(response.data.token)
                  break;
                default:
                    setSession({
                        type: AUTH_FAIL,
                        payload: response.data
                    })
            }
        }).catch(error => {
            console.error(error)
        });
    }

    const register = async data => {
        await AxiosClient().post(`${CONTROLLER_ACCOUNT}/register`, data)
        .then(response => {
            switch (response.status) {
                case 200:
                    tokenSuccess(response.data.token)
                  break;
                default:
                    setSession({
                        type: AUTH_FAIL,
                        payload: response.data
                    })
            }
        }).catch(error => {
            console.error(error)
        });
    }

    const tokenSuccess = async token => {
        if (!token) throw new Error(`Parece que hay un problema con el token. Token: ${token}`)
        setSession({
            type: TOKEN_SUCCESS,
            payload: token
        })
        setTimeout(() => {
            AxiosClient().get(`${CONTROLLER_ACCOUNT}/claims`)
            .then(response => {
                switch (response.status) {
                    case 200:
                        subscriptions(response.data);
                    break;
                    default:
                        setSession({
                            type: AUTH_FAIL,
                            payload: response.data
                        })
                }
            }).catch(error => {
                console.error(error)
            })
        }, 0)
    }

    const subscriptions = claims => {
        AxiosClient().get(`${CONTROLLER_STRIPE}/customer/subscriptions`)
            .then(response => {
                console.log(response)
                switch (response.status) {
                    case 200:
                        if(response.data.data.length > 0)
                            setSession({ 
                                type: AUTH_ACTIVE,
                                payload: claims 
                            })
                    break;
                    default:
                        setSession({
                            type: AUTH_SUCCESS,
                            payload: claims
                        });
                }
            })
            .catch(error => {
                console.error(error)
            })
    }

    const subcribe = () =>{
        setSession({ type: SUBS_ACTIVE });
    }
    
    return (
        <AuthContext.Provider value={{
                authenticated: session.authenticated,
                subcribed: session.subcribed,
                claims: session.claims,
                register: register,
                login: login, 
                logout: logout,
                refresh: refresh,
                subcribe: subcribe,
                error: session.error
             }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthState
